import firebase from 'firebase/app'
import 'firebase/auth'

export const signIn = () => {
  const provider = new firebase.auth.GoogleAuthProvider()
  firebase.auth().signInWithPopup(provider)
}

export const signOut = () => {
  firebase.auth().signOut()
}

export const adminUserConnected = () => {
  return !!firebase.auth().currentUser
}

export const getAdminEmail = () => {
  return firebase.auth().currentUser?.email || false
}

export const clientCheckAdminEmail = () => {
  const email = getAdminEmail()
  if (email !== false) {
    return email.includes('@tamedia.ch')
  }
}

export const getAdminDisplayName = () => {
  return firebase.auth().currentUser?.displayName || null
}
